<template>
    <div class="container-fluid p-0">
        <div
            v-for="area in sortedAreas"
            :key="area.id"
            class="row align-items-center px-2 selection-row"
            style="min-height: 44px; cursor: pointer;"
            @click.stop="$emit('areaSelected', area)"
        >
            <div class="col-auto pe-1">
                <span
                    v-if="area.color"
                    class="area-color-swatch"
                    :style="{ backgroundColor: area.color }"
                />
            </div>
            <div class="col text-truncate">
                {{ displayName(area) }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AreaSelectorModal',

    props: {
        areas: {
            type: Array,
            required: true
        }
    },

    emits: ['areaSelected'],

    data() {
        return {}
    },

    computed: {
        sortedAreas() {
            return [...this.areas].sort((a, b) => {
                const nameA = (a.name || '').trim()
                const nameB = (b.name || '').trim()
                const nameCompare = nameA.localeCompare(nameB)
                if (nameCompare !== 0) return nameCompare
                return a.id - b.id
            })
        }
    },

    methods: {
        displayName(area) {
            if (area.name && area.name.trim().length > 0) {
                return area.name
            }
            return this.$t('areas.area') + ' ' + area.id
        }
    }
}
</script>

<style scoped>
.selection-row {
    border-bottom: 1px solid #d9d9d9;
    cursor: pointer;
}

.selection-row:hover {
    background: #dff1bd;
}

.area-color-swatch {
    display: inline-block;
    width: 1em;
    height: 1em;
    border-radius: 2px;
    vertical-align: middle;
}
</style>
